import { styled } from "@mui/material/styles";
import { Box, Button, Card, Grid, IconButton, Stack } from "@mui/material";
import InsertPhotoIcon from "@mui/icons-material/InsertPhoto";
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";
import ImagePicker from "../common/ImagePicker";
import CellImage from "../common/CellImage";

const Uploader = ({ images, multiple = false, size = 60, onUploaded, ...props }) => {
  function handleUpload() {
    ImagePicker({
      multiple,
      onSelect(image) {
        let _images = image;
        if (multiple) {
          _images = images ? `${images},${image}` : image;
        }
        onUploaded(_images);
      },
    });
  }

  function handleDelete(idx) {
    const imgs = images.split(",");
    imgs.splice(idx, 1);
    onUploaded(imgs.join(","));
  }

  if (!multiple) {
    return (
      <Stack
        alignItems="center"
        justifyContent="center"
        sx={{
          position: 'relative',
          width: size,
          height: size,
          cursor: "pointer",
          borderRadius: "4px",
          border: "1px dotted rgba(0,0,0,.1)",
          backgroundColor: "rgba(0,0,0,.02)",
        }}
        onClick={() => {
          if (images) {
            return;
          } 

          handleUpload()
        }}
      >
        {images ? <CellImage preview src={`${images}`} style={{ width: "100%", height: "100%", borderRadius: 4 }} /> : <InsertPhotoIcon sx={{ color: "#aaa" }} />}

        <div className="rcc" style={{ position: "absolute", right: -10, top: -10, backgroundColor: "rgba(255, 255, 255, 1)", borderRadius: "50%", cursor: "pointer" }} onClick={() => handleDelete(0)}>
          <RemoveCircleOutlineIcon />
        </div>
      </Stack>
    );
  }

  return (
    <Stack direction="row" alignItems="flex-start" {...props}>
      <Grid columns={5} container columnSpacing={2}>
        {!images
          ? null
          : images.split(",").map((img, i) => (
              <Grid item key={i} sx={{ position: "relative" }}>
                <CellImage preview src={`${img}`} style={{ width: size, height: size, border: "1px dotted rgba(0,0,0,.1)" }} />

                <div className="rcc" style={{ position: "absolute", right: -10, top: -10, backgroundColor: "rgba(255, 255, 255, 1)", borderRadius: "50%", cursor: "pointer" }} onClick={() => handleDelete(i)}>
                  <RemoveCircleOutlineIcon />
                </div>
              </Grid>
            ))}

        <Grid item>
          <Stack
            alignItems="center"
            justifyContent="center"
            sx={{
              width: 60,
              height: 60,
              flexShrink: 0,
              cursor: "pointer",
              borderRadius: "4px",
              border: "1px dotted rgba(0,0,0,.1)",
              backgroundColor: "rgba(0,0,0,.02)",
            }}
            onClick={handleUpload}
          >
            <InsertPhotoIcon sx={{ color: "#aaa" }} />
          </Stack>
        </Grid>
      </Grid>
    </Stack>
  );
};

export default Uploader;
